import { ref } from "vue";
import { useRouter } from "vue-router";

const isLoggedIn = ref<boolean>(!!localStorage.getItem("gcU"));

export const useAuth = () => {
  const router = useRouter();

  const login = () => {
    isLoggedIn.value = true;
  };

  const logout = () => {
    const idToken = localStorage.getItem("gcU") ? atob(JSON.parse(localStorage.getItem("gcU")!).idt) : null;

    localStorage.removeItem("gcU");
    isLoggedIn.value = false;

    const postLogoutRedirectUri = encodeURIComponent(`${window.location.origin}/`);
    const ssoApiUrl = process.env.VUE_APP_GUJ_SSO_API_URL;
    const ssoClient = process.env.VUE_APP_GUJ_SSO_CLIENT;

    if (ssoApiUrl && ssoClient && idToken) {
      window.location.href = `${ssoApiUrl}/${ssoClient}/logout?id_token_hint=${idToken}&post_logout_redirect_uri=${postLogoutRedirectUri}`;
    } else {
      router.push("/");
    }
  };

  const checkLoginStatus = () => {
    const userRaw = localStorage.getItem("gcU");
    const expiresAt = localStorage.getItem("gcU_exp");

    if (!userRaw || !expiresAt) {
      localStorage.removeItem("gcU");
      localStorage.removeItem("gcU_exp");
      isLoggedIn.value = false;
      return;
    }

    const now = Date.now();

    if (now > Number(expiresAt)) {
      localStorage.removeItem("gcU");
      localStorage.removeItem("gcU_exp");
      isLoggedIn.value = false;
    } else {
      isLoggedIn.value = true;
    }
  };

  return {
    isLoggedIn,
    login,
    logout,
    checkLoginStatus,
  };
};
